function createOverlay(image) {
  // Crear la imagen de overlay
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', image.src);
  
  // Crear el contenedor del overlay
  const overlay = document.createElement('div');
  
  // Preparar el overlay
  prepareOverlay(overlay, overlayImage);
  
  // Reducir opacidad de la imagen original
  image.style.opacity = '0.5';
  
  // // Buscar el spinner de carga más cercano
  // const loadingSpinner = image.closest('.product-media-container')?.querySelector('.loading__spinner');
  
  // // Alternar visibilidad del spinner si existe
  // if (loadingSpinner) {
  //   loadingSpinner.classList.toggle('hidden');
  // }
  
  // Al cargar la imagen
  overlayImage.onload = () => {
    // Restaurar opacidad de la imagen original
    image.style.opacity = '1';
    
    // Ocultar spinner si existe
    // if (loadingSpinner) {
    //   loadingSpinner.classList.toggle('hidden');
    // }
    
    // Insertar overlay justo antes de la imagen
    image.parentElement.insertBefore(overlay, image);
  };
  
  return overlay;
}

function prepareOverlay(container, image) {
  // Configurar clases y atributos del overlay
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  
  // Configurar fondo del overlay
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  
  // Configuraciones adicionales de estilo
  container.style.backgroundSize = 'cover';
  container.style.backgroundPosition = 'center';
  container.style.position = 'absolute';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.zIndex = '10';
}

function moveWithHover(image, event, zoomRatio) {
  // Calcular posición del ratón
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  
  // Calcular porcentajes de posición
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;
  
  // Encontrar el overlay
  const overlay = document.querySelector('.image-magnify-full-size');
  
  if (overlay) {
    // Configurar posición y tamaño del fondo
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }
}

function magnify(image, zoomRatio, event) {
  // Crear overlay
  const overlay = createOverlay(image);
  
  // Insertar overlay en el DOM antes de aplicar `moveWithHover`
  image.parentElement.insertBefore(overlay, image);
  
  // Llamar inmediatamente a moveWithHover después de asegurarnos de que el overlay existe
  moveWithHover(image, event, zoomRatio);

  // Configurar eventos del overlay
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (e) => moveWithHover(image, e, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
  
  return overlay;
}

function enableZoomOnHover(zoomRatio) {
  // Seleccionar todas las imágenes con la clase de zoom
  const images = document.querySelectorAll('.image-magnify-hover');
  
  images.forEach((image) => {
    // Añadir evento de clic
    image.onclick = (event) => {
      magnify(image, zoomRatio, event);
    };
  });
}

// Iniciar zoom con ratio de 2x
enableZoomOnHover(2);